
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"fill indigo-300",attrs:{"clip-rule":"evenodd","d":"M17.657 15.657a7.981 7.981 0 01-2.318 1.615L4.728 6.66a7.984 7.984 0 011.615-2.317L12 10l5.657 5.657z"}}),_c('path',{staticClass:"fill indigo-800",attrs:{"clip-rule":"evenodd","d":"M5.99 3.99a.5.5 0 01.707 0L12 9.293l3.646-3.647a.5.5 0 01.708.708L12.707 10l5.303 5.303a.5.5 0 010 .707 8.482 8.482 0 01-2.462 1.716A8.503 8.503 0 014.274 6.452 8.484 8.484 0 015.99 3.99zm-.656 2.569L15.44 16.666a7.47 7.47 0 001.497-1.02L6.355 5.061a7.47 7.47 0 00-1.021 1.497zM14.45 17.09L4.91 7.55a7.5 7.5 0 001.787 7.753 7.5 7.5 0 007.754 1.787z"}}),_c('path',{staticClass:"fill indigo-800",attrs:{"clip-rule":"evenodd","d":"M5.636 3.636a1 1 0 011.414 0L12 8.586l3.293-3.293a1 1 0 111.414 1.414L13.414 10l4.95 4.95a1 1 0 010 1.414 8.965 8.965 0 01-3.688 2.23l1.172 1.876A1 1 0 0115 22H5a1 1 0 01-.848-1.53l2.176-3.482a9 9 0 01-.692-13.352zM8.011 18.07L6.804 20H9v-1.513a8.955 8.955 0 01-.99-.417zm2.989.875V20h2.196l-.636-1.017c-.52.032-1.042.02-1.56-.038zM6.393 5.807a7.001 7.001 0 009.8 9.8l-9.8-9.8z"}}),_c('path',{staticClass:"fill indigo-800",attrs:{"d":"M18 6a2 2 0 11-4 0 2 2 0 014 0z"}}),_c('path',{staticClass:"fill indigo-500",attrs:{"clip-rule":"evenodd","d":"M1.5 0a.5.5 0 01.5.5V1h.5a.5.5 0 010 1H2v.5a.5.5 0 01-1 0V2H.5a.5.5 0 010-1H1V.5a.5.5 0 01.5-.5zm20 9a.5.5 0 01.5.5v.5h.5a.5.5 0 010 1H22v.5a.5.5 0 01-1 0V11h-.5a.5.5 0 010-1h.5v-.5a.5.5 0 01.5-.5z"}}),_c('path',{staticClass:"fill indigo-500",attrs:{"d":"M13 2a1 1 0 11-2 0 1 1 0 012 0zM2 16a1 1 0 11-2 0 1 1 0 012 0zM21 20a1 1 0 11-2 0 1 1 0 012 0z"}})])
          )
        }
      }
    